import { useAuth } from '@/lib/auth';

export interface ImpersonationState {
  /** True when the current session is an admin "view as user" session. */
  isImpersonating: boolean;
  /** The admin UID that initiated the impersonation, if present in the claim. */
  impersonatedBy: string | null;
}

/**
 * useImpersonation — claim-driven "view as user" detection.
 *
 * The Firebase custom claim { impersonation: true, impersonated_by: <adminUid> }
 * is the single source of truth. It is read on every token change inside the
 * AuthProvider (see src/lib/auth.tsx) and survives refresh with the token — we
 * never read or write sessionStorage/localStorage for this. Consumers use this
 * to render the global impersonation banner and to gate any "read-only" UX.
 */
export function useImpersonation(): ImpersonationState {
  const { isImpersonating, impersonatedBy } = useAuth();
  return { isImpersonating, impersonatedBy };
}
